class PageJump extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector("form");
    const input = this.querySelector('input[type="number"]');
    if (!form || !input) return;
    
    form.addEventListener('submit', function (e) {
        e.preventDefault();
        
        let page = parseInt(input.value, 10);
        const url = new URL(window.location.href);
        url.searchParams.set('page', page);
        window.location.href = url.toString();
    });
  }
}
if (!customElements.get("page-jump")) {
  customElements.define("page-jump", PageJump);
}
